import React from 'react'

import {dashboardTemplatesProject} from "../../../../../../../../../app/quick-add/sections/dashboard/templates/templates-project"
import {createProjectDashboard} from "../../../../../../../../../app/quick-add/sections/dashboard/actions/create-project-dashboard"
import FormManager from "../../../../../../../../../core/gd-form/common/form-manager"
import FieldFormElement from "../../../../../../../../../core/fields3/render/form-elemnent"
import FormError from "../../../../../../../../../core/gd-form/common/form-error/form-error"
import ButtonSubmit from "../../../../../../../../../core/gd-form/common/btn-submit/btn-submit-ui5-new"
import FieldsFactory from "../../../../../../../../../core/fields3/fields-factory"
import {FieldType} from "../../../../../../../../../core/fields3/field-type"
import {ViewTypeConfigs, ViewTypeSystemConfig} from "../../../../../../../../../core/gd/const/views/view-type-config"
import AddViewRowTitle from "../row-title/row-title"
import {ViewType} from "../../../../../../../../../core/gd/const/views/view-type";
import {AddView_OptionConfig} from "../../../../../../../../../core/gd-ui/add-view/@types";
import AddView_SelectView from "./select-view"
import AddView_ViewHeader from "./view-header"

type Props = {
    config      : AddView_OptionConfig

    hidePopover : func
    onBack      : func
}

const debug = false
// const debug = "AddViewPreviewDashboardForm"

export default function AddViewPreviewDashboardForm(props: Props) {

    const onSubmit = (values: any) => {
        const template: any = _.find(dashboardTemplatesProject, template=>template.templateId === values.templateId)
        debug && console.log(debug, "onSubmit", values)

        createProjectDashboard(props.config.formParams.projectId, template, {dashboardName: values.name})
        props.hidePopover()
    }

    const templatesOptions: any[]   = []

    const viewConfig = ViewTypeConfigs[ViewType.PROJECT_DASHBOARD]!

    const name = viewConfig.name

    const initFormData = {
        name        : name,
        templateId  : 'project-empty',
    }

    const formStructure = {
        fields              : {
            name        : { type: 'input',    isRequired: true},
            templateId  : { type: 'select'},
        },
        onSubmit            : onSubmit,
        isFormChanged       : true,
    }

    const form = new FormManager(formStructure, initFormData)

    _.map(dashboardTemplatesProject, template => {
        templatesOptions.push({
            label: template.name,
            value: template.templateId
        })
    })

    debug && console.log(debug, "render", templatesOptions, dashboardTemplatesProject)

    const fieldName = FieldsFactory.get({
        fieldId         : 'name',
        label           : 'Name',
        type            : FieldType.STRING,
        isRequired      : true,
        description     : 'A descriptive title for the dashboard.'
    })

    const fieldTemplate = FieldsFactory.get({
        fieldId         : 'templateId',
        type            : FieldType.DROPDOWN,
        label           : 'Template',
        options         : templatesOptions,
        showMenuMore    : false,
        noValueOption   : false,
        description     : 'Select a layout template for the dashboard view.'
    })

    return (
        <div className="flex-column-left-top h-100-percent p-l-10 p-r-10">
            <AddView_SelectView onBack={props.onBack}/>
            <AddView_ViewHeader viewConfig={viewConfig}/>

            <div className="flex-column-left-top w-100-percent m-t-30">
                <div className="flex-column-left-top w-100-percent">
                    <AddViewRowTitle field={fieldName}/>
                    <FieldFormElement className="w-100-percent" field={fieldName} form={form}/>
                    <FormError form={form} name="name"/>
                </div>

                <div className="flex-column-left-top w-100-percent m-t-15">
                    <AddViewRowTitle field={fieldTemplate}/>
                    <FieldFormElement className="w-100-percent" field={fieldTemplate} form={form}/>
                </div>
            </div>

            <div className="h-100-percent"/>

            <div className="flex-row-center-center w-100-percent m-b-30">
                <ButtonSubmit size="36" form={form} label="Add view"/>
            </div>
        </div>
    )
}
